import React from 'react'
import { Button, Table, Th, Td, Tr, Badge } from '@/shared/ui'
import { Pagination } from '@/shared/ui/Pagination'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { listAffiliatePayoutsPaged, extractPayoutReceiptFromRow } from '../services/affiliatePayoutService'

function cents(v?: number|null){ return `R$ ${(Number(v||0)/100).toFixed(2)}` }
function iso(v?: string|null){ return v ? new Date(v).toLocaleString() : '—' }

export default function MyPayoutsPanel(){
  const { profile } = useAuth()
  const uid = profile?.id || ''
  const [items, setItems] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string|null>(null)
  const [total, setTotal] = React.useState(0)
  const [page, setPage] = React.useState(1)
  const pageSize = 25
  React.useEffect(()=>{(async()=>{
    if(!uid) return
    setLoading(true); setError(null)
    try{
      const { rows, total } = await listAffiliatePayoutsPaged(uid, page, pageSize)
      setItems(rows); setTotal(total)
    }catch(e:any){ setError(e?.message||'Falha ao carregar recebimentos') } finally{ setLoading(false) }
  })()},[uid, page])
  return (
    <div className="mt-8">
      <div className="mb-3 text-base font-medium">Recebíveis</div>
      {error && <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
      <Table>
        <thead>
          <Tr>
            <Th>Data</Th>
            <Th>Status</Th>
            <Th>Valor</Th>
            <Th>Comprovante</Th>
            <Th>Pago em</Th>
          </Tr>
        </thead>
        <tbody>
          {items.map(p=> {
            const receipt = extractPayoutReceiptFromRow(p)
            return (
              <Tr key={p.id}>
                <Td>{iso(p.created_at)}</Td>
                <Td><Badge variant="soft" className="capitalize">{p.status}</Badge></Td>
                <Td>{cents(p.amount_cents)}</Td>
                <Td>
                  {receipt && receipt.url
                    ? (
                      <Button
                        variant="outline"
                        className="h-7 px-2 text-xs"
                        onClick={()=>{ window.open(receipt.url, '_blank', 'noopener,noreferrer') }}
                      >
                        Baixar comprovante
                      </Button>
                    )
                    : <span className="text-xs text-foreground/60">-</span>
                  }
                </Td>
                <Td>{iso(p.paid_at)}</Td>
              </Tr>
            )
          })}
          {items.length===0 && <Tr><Td colSpan={5} className="py-6 text-center text-sm text-foreground/70">Nenhum recebimento ainda.</Td></Tr>}
        </tbody>
      </Table>
      <div className="mt-4 flex justify-end">
        <Pagination page={page} total={Math.max(1, Math.ceil(total / pageSize))} onChange={setPage} />
      </div>
    </div>
  )
}
